module.exports = __webpack_public_path__ + "static/media/rsna18-day-1.ec45c9de.svg";